export default "__VITE_ASSET__CLu4mUsP__"